'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _msNAME$quoteConstant;
var _formOptions = require('@marmalade/marker-study/lib/form-options');
var _constants = require('./new-business/constants');
var _reducer = require('./new-business/reducer');
var _reducer2 = _interopRequireDefault(_reducer);
var _reducer3 = require('./customer/reducer');
var _reducer4 = _interopRequireDefault(_reducer3);
var _constants2 = require('./customer/constants');
var _quote = require('./quote');
var _constants3 = require('./mta/constants');
var _constants4 = require('./renewal/constants');
var _reducer5 = require('./mta/reducer');
var _reducer6 = _interopRequireDefault(_reducer5);
var _reducer7 = require('./renewal/reducer');
var _reducer8 = _interopRequireDefault(_reducer7);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
exports.default = (_msNAME$quoteConstant = {}, _defineProperty(_msNAME$quoteConstant, _formOptions.NAME, _formOptions.reducer), _defineProperty(_msNAME$quoteConstant, _quote.constants.NAME, _quote.reducer), _defineProperty(_msNAME$quoteConstant, _constants2.NAME, _reducer4.default), _defineProperty(_msNAME$quoteConstant, _constants.NAME, _reducer2.default), _defineProperty(_msNAME$quoteConstant, _constants4.NAME, _reducer8.default), _defineProperty(_msNAME$quoteConstant, _constants3.NAME, _reducer6.default), _msNAME$quoteConstant);